
<div class="header-toolbar">
  <h1 *ngIf="mode === 'edit' || mode === 'new'">{{ title }}</h1>
  <h1 *ngIf="mode === 'view'">
    {{ account?.name }}
    <span *ngIf="account?.deleted">Supprimé</span>
  </h1>
</div>


<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="account">

  <!-- Toolbar -->
  <div *ngIf="mode === 'edit' || mode === 'new'" class="main btn-toolbar">
        
    <button class="btn" type="submit" [disabled]="!account.valid">
      <t-icon name="check"></t-icon>
      <span class="text">Enregistrer</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>
  
  <div *ngIf="mode === 'view' && !account.deleted" class="main btn-toolbar">
        
    <div class="btn-group">    
      <div class="content">
        
        <a class="btn" [routerLink]="['edit']">
          <t-icon name="mode_edit"></t-icon>
          <span class="text">Modifier</span>
        </a>
        <button class="btn" (click)="delete()">
          <t-icon name="delete"></t-icon>
          <span class="text">Supprimer</span>
        </button>

      </div>
    </div>

  </div>

  <div *ngIf="mode === 'view' && account.deleted" class="main btn-toolbar">
        
    <button class="btn" (click)="restore()">
      <t-icon name="settings_backup_restore"></t-icon>
      <span class="text">Restaurer</span>
    </button>
    
    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="account">

    <div class="column">

      <div *ngIf="mode === 'edit' || mode === 'new'" class="panel">
        <h2>Compte client</h2>

        <div class="form-group">
          <label for="name">Nom</label>
          <input #nameInput id="name" type="text" placeholder="" [formControl]="name" maxlength="200"/>
          <span class="info info-error" [hidden]="name.valid || name.pristine || !name.errors.required">Ce champ est requis</span>
        </div>

      </div>

      <div *ngIf="mode === 'view'" class="panel">
        <h2>Compte client</h2>
      
        <div class="form-group">
          <label for="name">Nom</label>
          <span id="name" class="value">{{ account.name }}</span>
        </div>
      </div>

      <sl-authorization-list *ngIf="mode === 'view'" [account]="account" title="Entités accessibles par compte"></sl-authorization-list>

      <dl-authorization-list *ngIf="mode === 'view'" [account]="account" title="Sociétés & Registres accessibles par compte"></dl-authorization-list>
      
    </div>
    
    <div class="column">

      <div *ngIf="mode === 'view' || mode === 'edit'" class="panel">
        <h2>Autres</h2>
      
        <div class="form-group">
          <label for="id">Identifiant</label>
          <span id="id" class="value">{{ account.id }}</span>
        </div>
      
        <div class="form-group">
          <label for="createdAt">Date d'ajout</label>
          <span id="createdAt" class="value">{{ account.createdAt | tzdate }}</span>
        </div>
      
        <div class="form-group">
          <label for="updatedAt">Date de modification</label>
          <span id="updatedAt" class="value">{{ account.updatedAt | tzdate }}</span>
        </div>
      </div>

    </div>

  </div>

  <ng-container *ngIf="mode === 'view'">
    <cl-account-user-list [account]="account" title="Utilisateurs Actifs"></cl-account-user-list>

    <cl-account-user-list [account]="account" title="Utilisateurs Supprimés" [deleted]="true"></cl-account-user-list>
  </ng-container>
</form>